// extracted by mini-css-extract-plugin
export var box = "_88-1";
export var checkboxRow = "_88-8";
export var checked = "_88-2";
export var descriptionSpacer = "_88-a";
export var disabled = "_88-3";
export var icon = "_88-6";
export var input = "_88-0";
export var labelSpacer = "_88-9";
export var medium = "_88-5";
export var small = "_88-4";
export var text = "_88-7";